<tui-table-pagination
  [total]="total"
  [(page)]="page"
  [(size)]="size"
  (pageChange)="onPageChange($event)"
  (sizeChange)="onSizeChange($event)"
></tui-table-pagination>
<p>
  Current Page: <b>{{ page + 1 }}</b>
</p>
